import { withRetry } from '../utils/retry.js';

export class RecoveryResourcesService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }
    async getAll(params = {}) { return withRetry(() => this.api.getAll(params), this.config); }
    async getById(id) { return withRetry(() => this.api.getById(id), this.config); }
    async create(data) { return withRetry(() => this.api.create(data), this.config); }
    async update(id, data) { return withRetry(() => this.api.update(id, data), this.config); }
    async delete(id) { return withRetry(() => this.api.delete(id), this.config); }
    async batchDelete(ids) { return withRetry(() => this.api.batchDelete(ids), this.config); }
}
